import Topnavbar from "../../../Layouts/Topnavbar";
import { Container, Grid, Paper, Text, Title, Group, ThemeIcon, Button, Drawer, Select, Switch, Modal, Stack, Progress, PasswordInput, SimpleGrid, TextInput, Textarea, Center, Box, NumberInput, PinInput, Checkbox } from "@mantine/core";
import React, { useState, useEffect } from "react";
import {
    Table,
    Tag,
    Typography,
    Row,
    Col,
    DatePicker,
    Input,
    Space,
    Card, message, Descriptions, Divider, Empty, Spin
} from "antd";
import { Userauthcontexthooks } from "../../../Hooks/Userauthcontexthooks";
import dayjs from "dayjs";
import { IconCheck, IconX } from "@tabler/icons-react";
import { Distributor_Signup, Get_All_Users, Get_Individual_user_wallet_details, Update_Distributor_details, Update_user_wallet_hold_balance, Update_user_wallet_status } from "../../../apicall";

const { Search } = Input;










const Distributor = ({ Headername }) => {

    const columns = [
        {
            title: "S.No.",
            width: 60,
            align: "center",
            render: (_, __, index) => index + 1,
        },
        {
            title: "User Code",
            dataIndex: "userCode",
            width: 120,
            render: (code) => <Text copyable>{code}</Text>,
        },
        {
            title: "Name",
            dataIndex: "userName",
            width: 180,
        },
        {
            title: "Business Name",
            dataIndex: "business_name",
            width: 220,
        },
        {
            title: "Account Type",
            dataIndex: "acc_type",
            width: 120,
            render: (type) => (
                <Tag color={type === "Retailer" ? "blue" : "purple"}>
                    {type}
                </Tag>
            ),
        },
        {
            title: "Mobile",
            dataIndex: "mobile",
            width: 130,
            render: (mobile) => <Text copyable>{mobile}</Text>,
        },
        {
            title: "City",
            dataIndex: "city",
            width: 120,
        },
        {
            title: "State",
            dataIndex: "state",
            width: 120,
        },
        {
            title: "Pincode",
            dataIndex: "pincode",
            width: 100,
        },
        {
            title: "Created On",
            dataIndex: "createdAt",
            width: 170,
            render: (date) => dayjs(date).format("DD MMM YYYY"),
        },
        {
            title: "Action",
            width: 110,
            fixed: "right",
            render: (_, record) => (
                <Button
                    variant="outline"
                    size="xs"
                    onClick={() => {
                        setSelecteduser(record);
                        setUsersDrawer(true);
                    }}
                >
                    View
                </Button>
            ),
        },
    ];
    const { user } = Userauthcontexthooks();
    const [userStatustype, setUserstatus] = useState("ALL");
    const [searchuser, setSearchuser] = useState("");
    const [UsersDrawer, setUsersDrawer] = useState(false);
    const [selectedUser, setSelecteduser] = useState(null);
    //const [userprofileLoading, setUserprofileLoading] = useState(true); // self profile
    //const [selfProfiledetails, setProfiledetails] = useState(''); // Self profile 
    const [userfindloading, setUserloading] = useState(true);
    const [mappedUsers, setMappedUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [walletData, setWalletData] = useState({});
    const [loadingWallet, setLoadingWallet] = useState({});
    const [Masterdistlist, setMasterdistlist] = useState([]);
    const [createModal, setCreateModal] = useState(false);
    const [createLoading, setCreateLoading] = useState(false);
    const [createProfile, setCreateProfile] = useState({
        master_dist_id: null,
        userName: "",
        email: "",
        mobile: "",
        distpassword: "",
        dob: null,
        gender: "",
        aadhar_no: "",
        pan_no: "",
        business_name: "",
        business_type: "",
        gst_no: "",
        msme_no: "",
        address: "",
        city: "",
        state: "",
        pincode: "",
        services: {
            topinRequest: true,
            walletToWalletTransfer: false,
            fundTransferMapped: true,
        }
    })
    const [updateWalletstatusloading, setWalletstatusloading] = useState(false);
    const [holdamount, setholdamount] = useState('');
    const [mpinModal, setMpinModal] = useState(false);
    const [mpin, setMpin] = useState("");
    const [holdLoading, setHoldLoading] = useState(false);

    const [editDistributorOpen, setEditDistributorOpen] = useState(false);

    const [editDistributor, setEditDistributor] = useState({
        _id: "",
        userName: "",
        email: "",
        mobile: "",
        dob: null,
        gender: "",
        aadhar_no: "",
        pan_no: "",
        business_name: "",
        business_type: "",
        gst_no: "",
        msme_no: "",
        address: "",
        city: "",
        state: "",
        pincode: "",
        master_dist_id: "",

        services: {
            topinRequest: true,
            walletToWalletTransfer: false,
            fundTransferMapped: true,
        }
    });

    const [editProfileLoading, setEditProfileLoading] = useState(false);


    const handleSearch = () => {
        let filtered = [...mappedUsers];

        // Status Filter
        if (userStatustype !== "ALL") {
            filtered = filtered.filter((item) =>
                userStatustype === "Active"
                    ? !item.isaccountblocked
                    : item.isaccountblocked
            );
        }

        // Search Filter
        if (searchuser.trim()) {
            const keyword = searchuser.toLowerCase().trim();

            filtered = filtered.filter((item) =>
                item.userName?.toLowerCase().includes(keyword) ||
                item.userCode?.toLowerCase().includes(keyword) ||
                String(item.mobile).includes(keyword)
            );
        }

        setFilteredUsers(filtered);
    };

    const handleReset = () => {
        setUserstatus("ALL");
        setSearchuser("");
        setFilteredUsers(mappedUsers);
    };

    const handleExpand = async (expanded, record) => {
        if (!expanded) return;
        //console.log(record);

        // Don't fetch again if already loaded
        if (walletData[record._id]) return;

        try {
            setLoadingWallet((prev) => ({
                ...prev,
                [record._id]: true,
            }));

            const data = await Get_Individual_user_wallet_details(record._id);

            if (data.success) {
                //console.log(data);

                setWalletData((prev) => ({
                    ...prev,
                    [record._id]: data.Userwallet,
                }));
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setLoadingWallet((prev) => ({
                ...prev,
                [record._id]: false,
            }));
        }
    };

    const update_user_wallet_status = async (record) => {
        const wallet = walletData[record._id];
        if (!wallet) {
            message.error('User wallet not found');
            return;
        }
        //console.log(wallet._id);

        const body = {
            walletid: wallet?._id,
            updatedWalletStatus: wallet?.isWalletBlocked === true ? false : true
        }

        try {
            setWalletstatusloading(true);
            const data = await Update_user_wallet_status(body);
            if (data.success) {
                //console.log(data);
                message.success(data.message);
                message.info('Please refresh the page for updated status');
                setWalletData({});
                setLoadingWallet({});
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setWalletstatusloading(false);
        }

    }

    const update_user_wallet_hold_balance = async () => {
        const wallet = Object.values(walletData)[0];

        //console.log(wallet._id);
        if (!wallet) {
            message.error('User wallet not found');
            return;
        }
        if (!holdamount) {
            message.error("Hold amount is required");
        }

        if (mpin === '' || mpin.length !== 6) {
            message.error("Please enter your 6 digit MPIN");
            return;
        }
        //console.log(wallet);

        const body = {
            walletid: wallet?._id,
            holdamount: holdamount,
            mpin
        }

        try {
            setHoldLoading(true);
            const data = await Update_user_wallet_hold_balance(body);
            if (data.success) {
                //console.log(data);
                message.success(data.message);
                message.info('Please refresh the page for updated status');
                setWalletData({});
                setLoadingWallet({});
                setMpinModal(false);
                setMpin('');
                setholdamount('');
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setHoldLoading(false);
        }

    }

    const expandedRowRender = (record) => {
        const wallet = walletData[record._id];

        if (loadingWallet[record._id]) {
            return <Spin />;
        }

        if (!wallet) {
            return <Empty description="No wallet found" />;
        }

        return (
            <Descriptions bordered size="small" column={3}>
                <Descriptions.Item label="Main Wallet">
                    ₹ {wallet.mainBalance}
                </Descriptions.Item>

                <Descriptions.Item label="Advance Credit">
                    ₹ {Math.abs(wallet.advanceCredit)}
                </Descriptions.Item>

                <Descriptions.Item label="Distributor Credit">
                    ₹ {Math.abs(wallet.distributorCredit)}
                </Descriptions.Item>

                <Descriptions.Item label="Master Dist Credit">
                    ₹ {Math.abs(wallet.masterDistributorCredit)}
                </Descriptions.Item>

                <Descriptions.Item label="Hold Amount">
                    ₹ {wallet.holdBalance}
                    <Button size="sm" variant="transparent" ml={'md'} onClick={() => setMpinModal(true)} loading={updateWalletstatusloading}>Update Hold</Button>
                </Descriptions.Item>

                <Descriptions.Item label="Wallet Status">
                    {wallet.walletStatus}
                    <Button size="sm" variant="transparent" ml={'md'} color={wallet?.isWalletBlocked ? 'green' : 'orange'} onClick={() => update_user_wallet_status(record)} loading={updateWalletstatusloading}>Update Status</Button>
                </Descriptions.Item>

                <Descriptions.Item label="Updated">
                    {dayjs(wallet.updatedAt).format("DD MMM YYYY hh:mm A")}
                </Descriptions.Item>
            </Descriptions>
        );
    };

    const handleInput = (e) => {
        const { name, value } = e.target;

        setCreateProfile((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleDOB = (value) => {
        setCreateProfile((prev) => ({
            ...prev,
            dob: value,
        }));
    };

    const handleService = (service, checked) => {
        setCreateProfile((prev) => ({
            ...prev,
            services: {
                ...prev.services,
                [service]: checked,
            },
        }));
    };

    const requirements = [
        {
            re: /[A-Z]/,
            label: "Includes at least one uppercase letter",
        },
        {
            re: /[a-z]/,
            label: "Includes at least one lowercase letter",
        },
        {
            re: /\d/,
            label: "Includes at least one number",
        },
        {
            re: /[@$!%*?&]/,
            label: "Includes at least one special character (@$!%*?&)",
        },
    ];
    const getStrength = (password) => {
        let multiplier = password.length >= 8 ? 0 : 1;

        requirements.forEach((requirement) => {
            if (!requirement.re.test(password)) {
                multiplier += 1;
            }
        });

        return Math.max(
            100 - (100 / (requirements.length + 1)) * multiplier,
            0
        );
    };
    function PasswordRequirement({ meets, label }) {
        return (
            <Text
                component="div"
                c={meets ? "teal" : "red"}
                mt={5}
                size="sm"
            >
                <Center inline>
                    {meets ? (
                        <IconCheck size={14} stroke={1.5} />
                    ) : (
                        <IconX size={14} stroke={1.5} />
                    )}
                    <Box ml={7}>{label}</Box>
                </Center>
            </Text>
        );
    }
    const strength = getStrength(createProfile.distpassword);
    const color =
        strength === 100
            ? "teal"
            : strength > 60
                ? "lime"
                : strength > 30
                    ? "yellow"
                    : "red";
    const checks = requirements.map((requirement, index) => (
        <PasswordRequirement
            key={index}
            label={requirement.label}
            meets={requirement.re.test(createProfile.distpassword)}
        />
    ));

    const masterDistributorOptions = Masterdistlist?.map((item) => ({
        value: item._id,
        label: `${item.userName} (${item.userCode})`,
    })) || [];

    const fetchMaster_and_dist = async () => {
        try {
            const data = await Get_All_Users();
            if (data.success) {
                //console.log(data);
                setMappedUsers(data?.distributorsLists);
                setFilteredUsers(data?.distributorsLists);
                setMasterdistlist(data?.masterDistributorLists)
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setUserloading(false);
        }
    }

    const CreateDistributor_Profile = async () => {
        const { userName, email, mobile, distpassword, dob, gender, aadhar_no, pan_no, business_name, business_type, gst_no, msme_no, address, city, state, pincode } = createProfile;
        if (!userName || !email || !mobile || !distpassword || !dob || !gender || !aadhar_no || !pan_no || !business_name || !business_type || !address || !city || !state || !pincode) {
            message.error('All fields are required');
            return;
        }
        if (mobile && (mobile.length > 10 || mobile.length < 10)) {
            message.error("Please enter valid 10 digit mobile number");
            return;
        }
        const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        if (!passwordRegex.test(distpassword)) {
            message.error('Incorrect Password');
            return
        }
        if (aadhar_no && (aadhar_no.length > 12 || aadhar_no < 12)) {
            message.error("Please enter valid 12 digit aadhar number");
            return;
        }
        if (pan_no && (pan_no.length > 10 || pan_no < 10)) {
            message.error("Please enter valid 10 digit pan number");
            return;
        }
        if (gst_no && (gst_no.length > 15 || gst_no < 15)) {
            message.error("Please enter valid 15 digit gst number");
            return;
        }
        if (msme_no && (msme_no.length > 19 || msme_no < 19)) {
            message.error("Please enter valid 19 digit msme number");
            return;
        }
        if (createProfile?.master_dist_id === null) {
            message.error("Please select Master distributor");
            return;
        }

        const body = {
            Distributorname: userName,
            Distributoremail: email,
            Distributormobilenumber: mobile,
            distpassword,
            dob,
            gender,
            aadhar_no,
            pan_no: pan_no.toLocaleUpperCase(),
            business_name, business_type,
            gst_no: gst_no.toLocaleUpperCase(), msme_no: msme_no.toLocaleUpperCase(),
            address, city, state, pincode,
            topinRequest: createProfile.services.topinRequest,
            walletToWalletTransfer: createProfile.services.walletToWalletTransfer,
            fundTransferMapped: createProfile.services.fundTransferMapped,
            master_dist_id: createProfile?.master_dist_id
        }
        try {
            setCreateLoading(true);
            const data = await Distributor_Signup(body);
            if (data.success) {
                //console.log(data);
                message.success(data?.message);
                setCreateProfile({
                    master_dist_id: "",
                    userName: "",
                    email: "",
                    mobile: "",
                    distpassword: "",
                    dob: null,
                    gender: "",
                    aadhar_no: "",
                    pan_no: "",
                    business_name: "",
                    business_type: "",
                    gst_no: "",
                    msme_no: "",
                    address: "",
                    city: "",
                    state: "",
                    pincode: "",
                    services: {
                        topinRequest: true,
                        walletToWalletTransfer: false,
                        fundTransferMapped: true,
                    }
                })
                setCreateModal(false);
                fetchMaster_and_dist();
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setCreateLoading(false);
        }

    }

    // Edit handeler
    const OpenDistributorEdit = () => {

        setEditDistributor({
            _id: selectedUser._id,
            userName: selectedUser.userName,
            email: selectedUser.email,
            mobile: selectedUser.mobile,
            dob: dayjs(selectedUser.dob),
            gender: selectedUser.gender,
            aadhar_no: selectedUser.aadhar_no,
            pan_no: selectedUser.pan_no,
            business_name: selectedUser.business_name,
            business_type: selectedUser.business_type,
            gst_no: selectedUser.gst_no,
            msme_no: selectedUser.msme_no,
            address: selectedUser.address,
            city: selectedUser.city,
            state: selectedUser.state,
            pincode: selectedUser.pincode,

            master_dist_id:
                selectedUser.master_dist_id?._id ||
                selectedUser.master_dist_id,

            services: {
                ...selectedUser.services
            }
        });

        setEditDistributorOpen(true);
    };

    const handleDistributorEdit = (e) => {

        const { name, value } = e.target;

        setEditDistributor((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleDistributorService = (service) => {

        setEditDistributor((prev) => ({
            ...prev,
            services: {
                ...prev.services,
                [service]: !prev.services[service],
            },
        }));

    };

    const handleUpdateProfile = async () => {
        try {
            setEditProfileLoading(true);
            const body = {
                ...editDistributor,
                dob: dayjs(editDistributor.dob).format("YYYY-MM-DD"),
                topinRequest: editDistributor?.services?.topinRequest,
                walletToWalletTransfer: editDistributor?.services?.walletToWalletTransfer,
                fundTransferMapped: editDistributor?.services?.fundTransferMapped,
            };

            const data = await Update_Distributor_details (body);

            if (data.success) {

                message.success(data.message);

                setEditDistributorOpen(false);
                setUsersDrawer(false);
                setSelecteduser(false);
                fetchMaster_and_dist();
            }

        } catch (error) {

            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );

        } finally {
            setEditProfileLoading(false);
        }
    };

    useEffect(() => {
        const fetchMaster_and_dist = async () => {
            try {
                const data = await Get_All_Users();
                if (data.success) {
                    //console.log(data);
                    setMappedUsers(data?.distributorsLists);
                    setFilteredUsers(data?.distributorsLists);
                    setMasterdistlist(data?.masterDistributorLists)
                }
            } catch (error) {
                console.log(error);
                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );
            } finally {
                setUserloading(false);
            }
        }

        if (user) {
            fetchMaster_and_dist();
        }

    }, [user])

    return (
        <>
            <Topnavbar Headername={Headername} />
            <Container size={'xl'} mt={'sm'}>
                <Title c={'dimmed'}>Distributor</Title>
                <Text size="xs">Manage distributor profile</Text>
            </Container>
            <Group mt={'sm'} justify="flex-end" mr={'sm'}>
                <Button size="md" variant="light" onClick={() => setCreateModal(true)}>Create Distributor Profile</Button>
            </Group>
            <Container size={'lg'} mt={'lg'}>
                <Card title="Listed users" style={{
                    width: "100%",
                }}>
                    <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
                        {/* <Col xs={24} md={4}>
                            <Select
                                placeholder="Retailers"
                                data={userTypeOptions}
                                value={whichuserLedger.userType}
                                onChange={handleUserTypeChange}
                                loading={userprofileLoading}
                            // style={{ width: "100%" }}
                            />
                        </Col> */}

                        <Col xs={24} md={4}>
                            <Select
                                value={userStatustype}
                                onChange={setUserstatus}
                                // style={{ width: "100%" }}
                                data={[
                                    { label: "ALL", value: "ALL" },
                                    { label: "Active", value: "Active" },
                                    { label: "Blocked", value: "Blocked" },
                                ]}
                            />
                        </Col>

                        <Col xs={24} md={6}>
                            <Search
                                placeholder="Search by Name / Mobile / User Code"
                                allowClear
                                value={searchuser}
                                onChange={(e) => setSearchuser(e.target.value)}
                                onSearch={handleSearch}
                            />
                        </Col>

                        <Col xs={24} md={6}>
                            <Space>
                                <Button
                                    type="primary"
                                    onClick={handleSearch}
                                >
                                    Search
                                </Button>

                                <Button
                                    onClick={handleReset}
                                    variant="light"
                                >
                                    Reset
                                </Button>
                                <Button type="secondary" variant="outline">
                                    Download
                                </Button>
                                <Button type="secondary" variant="outline">
                                    Refresh
                                </Button>
                            </Space>
                        </Col>
                    </Row>

                    <div style={{ width: "100%", overflowX: "auto" }}>
                        <Table
                            columns={columns}
                            expandable={{
                                expandedRowRender,
                                onExpand: handleExpand,
                            }}
                            dataSource={filteredUsers}
                            loading={userfindloading}
                            bordered
                            size="middle"
                            rowKey="_id"
                            pagination={{
                                pageSize: 10,
                                showSizeChanger: true,
                            }}
                        // scroll={{ x: 1200 }}
                        />
                    </div>

                </Card>
            </Container>

            <Drawer
                title="User Details"
                width={650}
                opened={UsersDrawer}
                onClose={() => setUsersDrawer(false)}
            >
                {selectedUser && (
                    <>
                        <Descriptions
                            title="Basic Information"
                            bordered
                            column={1}
                            size="small"
                        >
                            <Descriptions.Item label="User Code">
                                {selectedUser.userCode}
                            </Descriptions.Item>

                            <Descriptions.Item label="User Name">
                                {selectedUser.userName}
                            </Descriptions.Item>

                            <Descriptions.Item label="Business Name">
                                {selectedUser.business_name || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Account Type">
                                <Tag color="blue">
                                    {selectedUser.acc_type}
                                </Tag>
                            </Descriptions.Item>

                            <Descriptions.Item label="Gender">
                                {selectedUser.gender}
                            </Descriptions.Item>

                            <Descriptions.Item label="Mobile Number">
                                {selectedUser.mobile}
                            </Descriptions.Item>
                        </Descriptions>

                        <Divider />

                        <Descriptions
                            title="Business Information"
                            bordered
                            column={1}
                            size="small"
                        >
                            <Descriptions.Item label="Business Name">
                                {selectedUser.business_name}
                            </Descriptions.Item>

                            <Descriptions.Item label="Business Type">
                                {selectedUser.business_type}
                            </Descriptions.Item>

                            <Descriptions.Item label="GST Number">
                                {selectedUser.gst_no || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="MSME Number">
                                {selectedUser.msme_no || "-"}
                            </Descriptions.Item>
                        </Descriptions>

                        <Divider />

                        <Descriptions
                            title="KYC Information"
                            bordered
                            column={1}
                            size="small"
                        >
                            <Descriptions.Item label="PAN Number">
                                {selectedUser.pan_no}
                            </Descriptions.Item>

                            <Descriptions.Item label="Aadhaar Number">
                                {selectedUser.aadhar_no}
                            </Descriptions.Item>
                        </Descriptions>

                        <Divider />

                        <Descriptions
                            title="Address Information"
                            bordered
                            column={1}
                            size="small"
                        >
                            <Descriptions.Item label="Address">
                                {selectedUser.address}
                            </Descriptions.Item>

                            <Descriptions.Item label="City">
                                {selectedUser.city}
                            </Descriptions.Item>

                            <Descriptions.Item label="State">
                                {selectedUser.state}
                            </Descriptions.Item>

                            <Descriptions.Item label="Pincode">
                                {selectedUser.pincode}
                            </Descriptions.Item>
                        </Descriptions>
                        <Divider />

                        <Descriptions
                            title="Hierarchy"
                            bordered
                            column={1}
                            size="small"
                        >

                            <Descriptions.Item label="Master Distributor">

                                {selectedUser.master_dist_id
                                    ? `${selectedUser.master_dist_id.userName} (${selectedUser.master_dist_id.userCode})`
                                    : "-"}

                            </Descriptions.Item>

                        </Descriptions>

                        <Divider />

                        <Descriptions
                            title="Enabled/Disabled Services"
                            bordered
                            column={1}
                            size="small"
                        >
                            <Descriptions.Item label="Services">

                                <Space wrap>

                                    {Object.entries(selectedUser.services || {}).map(([key, value]) => (
                                        <Tag
                                            key={key}
                                            color={value ? "green" : "red"}
                                        >
                                            {key}
                                        </Tag>
                                    ))}

                                </Space>

                            </Descriptions.Item>

                        </Descriptions>

                        <Divider />

                        <Divider />

                        <Descriptions
                            title="Account Information"
                            bordered
                            column={1}
                            size="small"
                        >

                            <Descriptions.Item label="Password Changed">

                                {selectedUser.ispasswordchanged
                                    ? <Tag color="green">Yes</Tag>
                                    : <Tag color="red">No</Tag>}

                            </Descriptions.Item>

                            <Descriptions.Item label="MPIN Changed">

                                {selectedUser.ismpinchanged
                                    ? <Tag color="green">Yes</Tag>
                                    : <Tag color="red">No</Tag>}

                            </Descriptions.Item>

                            <Descriptions.Item label="Account Status">

                                {selectedUser.isaccountblocked
                                    ? <Tag color="red">Blocked</Tag>
                                    : <Tag color="green">Active</Tag>}

                            </Descriptions.Item>

                            <Descriptions.Item label="Created On">

                                {dayjs(selectedUser.createdAt).format("DD MMM YYYY hh:mm A")}

                            </Descriptions.Item>

                            <Descriptions.Item label="Updated On">

                                {dayjs(selectedUser.updatedAt).format("DD MMM YYYY hh:mm A")}

                            </Descriptions.Item>

                        </Descriptions>

                        <Group mt={'sm'} justify="flex-end">
                            <Button onClick={OpenDistributorEdit}>
                                Edit Profile
                            </Button>
                        </Group>
                    </>
                )}
            </Drawer>

            <Modal
                opened={createModal}
                onClose={() => setCreateModal(false)}
                title="Create Distributor"
                size="xl"
                centered
            >
                <SimpleGrid cols={2} spacing="md">
                    <Select
                        label="Select Master Distributor"
                        data={masterDistributorOptions}
                        value={createProfile.master_dist_id}
                        onChange={(value) =>
                            setCreateProfile(prev => ({ ...prev, master_dist_id: value }))
                        }
                        loading={userfindloading}
                        required
                    />
                </SimpleGrid>
                <Divider my="lg">Personal Information</Divider>
                <SimpleGrid cols={2} spacing="md">

                    <TextInput
                        label="Full Name"
                        name="userName"
                        value={createProfile.userName}
                        onChange={handleInput}
                        required
                    />

                    <TextInput
                        label="Email"
                        name="email"
                        value={createProfile.email}
                        onChange={handleInput}
                        required
                    />

                    <TextInput
                        label="Mobile"
                        name="mobile"
                        value={createProfile.mobile}
                        onChange={handleInput}
                        maxLength={10}
                        required
                    />
                    {/* <Text  size="xs">DOB </Text> */}
                    <DatePicker
                        value={createProfile.dob}
                        onChange={handleDOB}
                        placeholder="DOB (Required)"
                        style={{ width: "100%", marginTop: 18 }}
                        required
                    />
                    <Select
                        label="Gender"
                        data={[
                            { label: "Male", value: "Male" },
                            { label: "Female", value: "Female" },
                            { label: "Other", value: "Other" }
                        ]}
                        value={createProfile.gender}
                        onChange={(value) =>
                            setCreateProfile(prev => ({ ...prev, gender: value }))
                        }
                        required
                    />

                    <TextInput
                        label="Aadhar Number"
                        name="aadhar_no"
                        value={createProfile.aadhar_no}
                        onChange={handleInput}
                        maxLength={12}
                        required
                    />

                    <TextInput
                        label="PAN Number"
                        name="pan_no"
                        value={createProfile.pan_no}
                        onChange={handleInput}
                        maxLength={10}

                        required
                    />

                </SimpleGrid>

                <Divider my="lg">Business Information</Divider>

                <SimpleGrid cols={2}>

                    <TextInput
                        label="Business Name"
                        name="business_name"
                        value={createProfile.business_name}
                        onChange={handleInput}
                        required
                    />

                    <TextInput
                        label="Business Type"
                        name="business_type"
                        value={createProfile.business_type}
                        onChange={handleInput}
                        required
                    />

                    <TextInput
                        label="GST Number (Optional)"
                        name="gst_no"
                        value={createProfile.gst_no}
                        onChange={handleInput}
                        maxLength={15}
                    />

                    <TextInput
                        label="MSME Number (Optional)"
                        name="msme_no"
                        value={createProfile.msme_no}
                        onChange={handleInput}
                        maxLength={19}
                    />

                </SimpleGrid>

                <Divider my="lg">Address</Divider>

                <Textarea
                    label="Address"
                    name="address"
                    value={createProfile.address}
                    onChange={handleInput}
                    required
                />

                <SimpleGrid cols={3} mt="md">

                    <TextInput
                        label="City"
                        name="city"
                        value={createProfile.city}
                        onChange={handleInput}
                        required
                    />

                    <TextInput
                        label="State"
                        name="state"
                        value={createProfile.state}
                        onChange={handleInput}
                        required
                    />

                    <TextInput
                        label="Pincode"
                        name="pincode"
                        value={createProfile.pincode}
                        onChange={handleInput}
                        maxLength={6}
                        required
                    />

                </SimpleGrid>
                <Divider my="lg">Security </Divider>

                <SimpleGrid cols={2}>

                    <PasswordInput
                        label="Password"
                        name="distpassword"
                        value={createProfile.distpassword}
                        onChange={handleInput}
                        required
                    />

                </SimpleGrid>
                {
                    createProfile.distpassword !== '' && (
                        <>
                            <Progress
                                value={strength}
                                color={color}
                                size="sm"
                                mt="xs"
                                radius="xl"
                            />

                            <Text size="xs" mt={5} fw={600}>
                                Password Strength:{" "}
                                {strength === 100
                                    ? "Strong"
                                    : strength > 60
                                        ? "Good"
                                        : strength > 30
                                            ? "Weak"
                                            : "Very Weak"}
                            </Text>

                            <PasswordRequirement
                                label="Has at least 8 characters"
                                meets={createProfile.distpassword.length >= 8}
                            />

                            {checks}
                        </>
                    )
                }

                <Divider my="lg">Service Permissions </Divider>

                <Stack gap="xs">

                    <Switch
                        label="Top-In Request"
                        checked={createProfile.services.topinRequest}
                        onChange={(e) =>
                            handleService("topinRequest", e.currentTarget.checked)
                        }
                    />

                    <Switch
                        label="Wallet to Wallet Transfer"
                        checked={createProfile.services.walletToWalletTransfer}
                        onChange={(e) =>
                            handleService("walletToWalletTransfer", e.currentTarget.checked)
                        }
                    />

                    <Switch
                        label="Fund Transfer Mapped"
                        checked={createProfile.services.fundTransferMapped}
                        onChange={(e) =>
                            handleService("fundTransferMapped", e.currentTarget.checked)
                        }
                    />

                </Stack>

                <Group justify="flex-end" mt="xl">

                    <Button
                        variant="default"
                        onClick={() => setCreateModal(false)}
                    >
                        Cancel
                    </Button>

                    <Button
                        loading={createLoading}
                        onClick={CreateDistributor_Profile}
                    >
                        Create Distributor
                    </Button>

                </Group>
            </Modal>

            <Modal
                opened={mpinModal}
                onClose={() => setMpinModal(false)}
                title="Confirm Hold"
                centered
                radius="md"
                size="md"
            >
                <Stack>

                    <Paper withBorder p="md" radius="md">

                        <Stack gap={8}>

                            <NumberInput
                                label="Hold Amount"
                                placeholder="Enter hold amount"
                                value={holdamount}
                                onChange={(value) => setholdamount(value)}
                                min={0}
                                hideControls
                                withAsterisk
                            />


                        </Stack>

                    </Paper>

                    <Divider />

                    <Stack align="center">

                        <Text fw={600}>
                            Enter 6 Digit MPIN
                        </Text>

                        <PinInput
                            length={6}
                            oneTimeCode={false}
                            type="number"
                            value={mpin}
                            onChange={setMpin}
                            mask
                            size="lg"
                        />

                    </Stack>

                    <Button
                        fullWidth
                        size="md"
                        loading={holdLoading}
                        // color="green"
                        onClick={update_user_wallet_hold_balance}
                    >
                        Confirm Hold ₹ {Number(holdamount).toLocaleString()}
                    </Button>

                </Stack>
            </Modal>

            <Modal
                opened={editDistributorOpen}
                onClose={() => setEditDistributorOpen(false)}
                title="Edit Distributor Profile"
                size="xl"
                centered
            >
                <Stack>

                    <SimpleGrid cols={2}>

                        <TextInput
                            label="User Name"
                            name="userName"
                            value={editDistributor.userName}
                            onChange={handleDistributorEdit}
                        />

                        <TextInput
                            label="Email"
                            name="email"
                            value={editDistributor.email}
                            onChange={handleDistributorEdit}
                        />

                        <TextInput
                            label="Mobile"
                            name="mobile"
                            value={editDistributor.mobile}
                            onChange={handleDistributorEdit}
                        />

                        <DatePicker
                            label="Date of Birth"
                            value={editDistributor.dob}
                            onChange={(value) =>
                                setEditDistributor(prev => ({
                                    ...prev,
                                    dob: value
                                }))
                            }
                            style={{ width: "100%", marginTop: 18 }}
                        />

                        <Select
                            label="Gender"
                            data={[
                                "Male",
                                "Female",
                                "Other"
                            ]}
                            value={editDistributor.gender}
                            onChange={(value) =>
                                setEditDistributor(prev => ({
                                    ...prev,
                                    gender: value
                                }))
                            }
                        />

                    </SimpleGrid>

                    <Divider >Business Details</Divider>

                    <SimpleGrid cols={2}>


                        <TextInput
                            label="PAN Number (NON-Editable)"
                            name="pan_no"
                            value={editDistributor.pan_no}
                            onChange={handleDistributorEdit}
                            readOnly
                        />

                        <TextInput
                            label="Aadhaar Number (NON-Editable)"
                            name="aadhar_no"
                            value={editDistributor.aadhar_no}
                            onChange={handleDistributorEdit}
                            readOnly
                        />

                        <TextInput
                            label="Business Name"
                            name="business_name"
                            value={editDistributor.business_name}
                            onChange={handleDistributorEdit}
                        />

                        <TextInput
                            label="Business Type"
                            name="business_type"
                            value={editDistributor.business_type}
                            onChange={handleDistributorEdit}
                        />

                        <TextInput
                            label="GST Number"
                            name="gst_no"
                            value={editDistributor.gst_no}
                            onChange={handleDistributorEdit}
                        />

                        <TextInput
                            label="MSME Number"
                            name="msme_no"
                            value={editDistributor.msme_no}
                            onChange={handleDistributorEdit}
                        />
                    </SimpleGrid>

                    <Divider>Hierarchy Details</Divider>
                    <Text c={'red'}>
                        Note: If, you want to change user hierarchy kindly use the User Swap option in admin panel
                    </Text>
                    <SimpleGrid cols={2}>

                        <TextInput
                            label="Master Distributor"
                            name="master_dist_id"
                            value={selectedUser?.master_dist_id
                                ? `${selectedUser?.master_dist_id.userName} (${selectedUser?.master_dist_id?.userCode})`
                                : "-"}
                            readOnly
                        />
                    </SimpleGrid>



                    <Divider>Address </Divider>

                    <SimpleGrid cols={2}>
                        <Textarea
                            label="Address"
                            name="address"
                            value={editDistributor.address}
                            onChange={handleDistributorEdit}
                        />
                        <TextInput
                            label="City"
                            name="city"
                            value={editDistributor.city}
                            onChange={handleDistributorEdit}
                        />

                        <TextInput
                            label="State"
                            name="state"
                            value={editDistributor.state}
                            onChange={handleDistributorEdit}
                        />

                        <TextInput
                            label="Pincode"
                            name="pincode"
                            value={editDistributor.pincode}
                            onChange={handleDistributorEdit}
                        />
                    </SimpleGrid>

                    <Divider>Service Permissions </Divider>
                    <SimpleGrid cols={2}>
                        <Checkbox
                            label="Topin Request"
                            checked={editDistributor.services.topinRequest}
                            onChange={() => handleDistributorService("topinRequest")}
                        />

                        <Checkbox
                            label="Wallet To Wallet Transfer"
                            checked={editDistributor.services.walletToWalletTransfer}
                            onChange={() => handleDistributorService("walletToWalletTransfer")}
                        />

                        <Checkbox
                            label="Fund Transfer Mapped"
                            checked={editDistributor.services.fundTransferMapped}
                            onChange={() => handleDistributorService("fundTransferMapped")}
                        />
                    </SimpleGrid>

                    <Divider>Account Status</Divider>

                    <Switch
                        label="Block Account"
                        checked={editDistributor.isaccountblocked}
                        onChange={(event) =>
                            setEditDistributor({
                                ...editDistributor,
                                isaccountblocked: event.currentTarget.checked
                            })
                        }
                    />

                    <Group justify="flex-end">

                        <Button
                            variant="default"
                            onClick={() => setEditDistributorOpen(false)}
                        >
                            Cancel
                        </Button>

                        <Button
                            onClick={handleUpdateProfile}
                            loading={editProfileLoading}
                        >
                            Update Profile
                        </Button>

                    </Group>

                </Stack>

            </Modal>
        </>
    )
}

export default Distributor;